import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Utils
import {greyishBlue500} from "assets/jss/main";
import {getTranslation} from "domain/helpers/translations";

WmsItemName.propTypes = {
    wmsItem: PropTypes.shape({
        lineItem: PropTypes.shape({
            retailer: PropTypes.object,
            brand: PropTypes.string,
            name: PropTypes.string
        })
    })
};
function WmsItemName({wmsItem}) {
    const retailer = wmsItem?.lineItem?.retailer;

    if (!retailer) {
        return null;
    }

    return (
        <Grid
            container
            direction={'row'}
            flexWrap={'nowrap'}
        >
            <Grid
                item
                style={{ maxHeight: '40px'}}
            >
                <img
                    style={{ borderRadius: '8px'}}
                    width={40}
                    height={40}
                    src={getTranslation(retailer)?.logo?.contentUrl || ""}
                    alt={'Retailer Logo'}
                />
            </Grid>
            <Grid item marginLeft={2}>
                <Grid
                    item
                    style={{
                        fontSize: '14px',
                        color: greyishBlue500,
                    }}
                >
                    {wmsItem.lineItem.brand}
                </Grid>
                <Grid
                    item
                    style={{
                        fontSize: '16px',
                        fontWeight: 600,
                    }}
                >
                    {wmsItem.lineItem.name}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default WmsItemName;
